import React from 'react';
import { useTranslation } from 'react-i18next';
import formatCurrency from '../../../utils/currencyFormatter';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import refreshIcon from '../../../img/default-svg/refresh.svg';
import refreshIconInex from '../../../img/inex/refresh.svg';
import refreshIconInsta from '../../../img/instaXchange/refresh.svg';
import refreshIconCoinera from '../../../img/coinera/refresh.svg';
import './style.scss';
import { identity } from "../../../utils/getIdentity";

const refreshIcons = {
  cpay: refreshIcon,
  nfg: refreshIcon,
  finvaro: refreshIcon,
  clarnium: refreshIcon,
  inex: refreshIconInex,
  insta: refreshIconInsta,
  coinera: refreshIconCoinera
}

const TotalBalance = ({
  merchantBalances,
  setIsHideZeroBalances,
  balancesTotal,
  getMerchantBalances,
  merchantId,
  networkFilter,
  balancesFetching,
}) => {
  const { t } = useTranslation();

  // useEffect(() => {
  //   if (merchantBalances && merchantBalances.length) {
  //     const sum = merchantBalances.reduce((sum, balance) => (sum += balance.balance.usd), 0);
  //     setTotalBalance(sum);

  //     if (sum <= 0) {
  //       setIsHideZeroBalances(false);
  //     } else {
  //       setIsHideZeroBalances(true);
  //     }
  //   }
  // }, [merchantBalances]);

  return (
    <div className={`total-balance total-balance-${identity}`}>
      <div className="total-balance__info">
        <div className="total-balance__info-wrapper">
          <span className={`total-balance__title total-balance__title-${identity}`}>{t('totalBalance')}</span>
          {balancesTotal && !balancesFetching ? (
            <button type="button" onClick={() => { console.log('getMerchantBalances called from TotalBalance/index.jsx refresh button, merchantId:', merchantId, 'networkFilter:', networkFilter, 'walletVersion:', localStorage.getItem('walletVersion')); getMerchantBalances(merchantId, networkFilter, true, false, localStorage.getItem('walletVersion')); }}>
              <img src={refreshIcons[identity]} alt="Refresh" />
            </button>
          ) : null}
        </div>
        {!balancesFetching ? (
          <>
            {balancesTotal ? (
              <>
                {identity !== "inex" && <span
                  className={`total-balance__balance total-balance__balance-${identity}`}>{balancesTotal?.btc || 0} BTC</span>}
                <span className={`total-balance__balance_usd total-balance__balance_usd-${identity}`}>
                  {identity !== 'inex' && '≈'}{balancesTotal?.usd ? formatCurrency(balancesTotal?.usd) : `$0.00`}
                </span>
              </>
            ) : null}
          </>
        ) : (
          <div className={`total-balance__loader total-balance__loader-${identity}`}>
            <p>...Loading data</p>
            <Spin indicator={<LoadingOutlined className={`spin-${identity}`} style={{ fontSize: 20 }} spin />} />
          </div>
        )}
      </div>
    </div>
  );
};

export default TotalBalance;
